import { Result, Button } from 'antd';
import { Link } from 'react-router';

const Forbidden = () => (
  <Result
    status='403'
    title='403 - Forbidden'
    subTitle='Sorry, you are not authorized to access this page.'
    extra={
      <Link to='/'>
        <Button type='primary'>Back to Home</Button>
      </Link>
    }
  />
);

export default Forbidden;
